import React from 'react'

function Support() {
  return (
    <>
        <div className="content-wrapper">
            <section className="support">
                <div className="small-container">
                    <h2 style={{textAlign:'center'}}>Contact on <br />pharmacymvl@gmail.com <br />or <br />+91 84008 83507</h2>
                </div>
            </section>
        </div>
    </>
  )
}

export default Support